import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      className={cn(
        "h-11 w-full rounded-xl border border-ink/10 bg-white px-3 text-sm text-ink outline-none transition placeholder:text-muted/70 focus:border-cinnabar-500 focus:ring-4 focus:ring-cinnabar-100",
        className
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "min-h-28 w-full rounded-xl border border-ink/10 bg-white px-3 py-3 text-sm text-ink outline-none transition placeholder:text-muted/70 focus:border-cinnabar-500 focus:ring-4 focus:ring-cinnabar-100",
        className
      )}
      {...props}
    />
  );
}

export function Select({ className, ...props }: ComponentProps<"select">) {
  return (
    <select
      className={cn(
        "h-11 w-full rounded-xl border border-ink/10 bg-white px-3 text-sm text-ink outline-none transition focus:border-cinnabar-500 focus:ring-4 focus:ring-cinnabar-100",
        className
      )}
      {...props}
    />
  );
}
